import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { statusMeta, STATUS_PLACED } from './order-enums';
import type { Order } from './types';

/**
 * The two cells every order list draws the same way — the global search and
 * the store's deliveries.
 */

export function StatusBadge({ status }: { status: number | null }) {
  const { t } = useTranslation();
  const meta = statusMeta(status);
  return (
    <span className="flex items-center gap-1.5">
      <Badge variant={meta.tone}>{t(meta.labelKey)}</Badge>
      {status === STATUS_PLACED && (
        <Badge variant="outline" className="text-[0.6rem]">
          {t('orders.new')}
        </Badge>
      )}
    </span>
  );
}

/** The service window, e.g. "9 AM – 11 AM". */
export function SlotRange({ order }: { order: Order }) {
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage === 'es' ? 'es-PR' : 'en-US';

  if (!order.startSlotTime || !order.endSlotTime) return '—';
  const format = (value: string) => {
    const date = new Date(/[zZ]$/.test(value) ? value : `${value}Z`);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(locale, { hour: 'numeric' }).format(date);
  };
  const start = format(order.startSlotTime);
  const end = format(order.endSlotTime);
  return start && end ? `${start} – ${end}` : '—';
}
